import React,{useState} from 'react'
import TextField from '@mui/material/TextField';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Checkbox} from 'antd';
import 'antd/dist/antd.css';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { alpha, styled } from '@mui/material/styles';

const CustomTextField = styled(TextField)({
    '& label.Mui-focused': {
      color: '#ffc043',
    },
    '& .MuiFilledInput-underline': {
        borderBottomColor: '#ffc043',
      },
    '& .MuiFilledInput-underline:after': {
      borderBottomColor: '#ffc043',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#ffc043',
      },
      '&:hover fieldset': {
        borderColor: '#ffc043',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#ffc043',
      },
    },
  });

const SubscribeSection = (props) => {

    const [name,setName] = useState('');
    const [email,setEmail] = useState('');
    const [phone,setPhone] = useState('');
    const [whatsapp_optin,setWhatsapp_optin]=useState('Yes')
    const [city,setCity] = useState('')
    const [whatsappNumber, setWhatsappNumber] = useState();
    let source = props.name;

    const handlePhone=(e)=>{
        setPhone(e.target.value);
        setWhatsappNumber(e.target.value);
    }

    const handleAlert=(e)=>{
        if(e.target.checked){
            setWhatsapp_optin("Yes")
            setWhatsappNumber(phone)
        }else{
            setWhatsapp_optin("No")
            setWhatsappNumber('')
        }
    }


    const handleSubmit = (e) => {

        
    e.preventDefault();
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if(name.length>0){
       if(regex.test(email)){
        if(phone.length===10){
            var xhr = new XMLHttpRequest();
            var url = 'https://api.hsforms.com/submissions/v3/integration/submit/6425754/8a7e4b5c-bfc4-4bb3-8c63-89ea99daf1d9'
            var data = {
                "fields": [
                    {
                        "name": "email",
                        "value": email
                    },
                    {
                        "name": "firstname",
                        "value": name
                    },
                    {
                        "name": "phone",
                        "value": phone
                    },
                    {
                        "name": "whatsapp_optin",
                        "value": whatsapp_optin
                    },
                    {
                        "name": "which_city_",
                        "value": city
                    },
                    {
                        "name": "whatsapp_number",
                        "value": whatsappNumber
                    },
                    {
                        "name": "website_source",
                        "value": source
                    }
                ],
            }
    
            var final_data = JSON.stringify(data)
    
            xhr.open('POST', url);
            // Sets the value of the 'Content-Type' HTTP request headers to 'application/json'
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    toast.success("Submitted Successfully") // Returns a 200 response if the submission is successful.
                } else if (xhr.readyState === 4 && xhr.status === 403) {
                    alert(xhr.responseText); // Returns a 403 error if the portal isn't allowed to post submissions.     
                } else if (xhr.readyState === 4 && xhr.status === 404) {
                    alert(xhr.responseText); //Returns a 404 error if the formGuid isn't found    
                } else if(xhr.readyState === 4 && xhr.status === 400){
                    toast.error("Invalid Inputs") // Returns a 400 error if the submission fails.
                }
            }
    
            // Sends the request 
            xhr.send(final_data)
            setName('');
            setEmail('');
            setPhone('');
            setCity('');
        }else{
            toast.error("Enter a 10 digit phone number.")
        }
       }else{
        toast.error("Enter a valid email.")
       }        
    }else{
        toast.error("Fill all the fields.")
    }       
    }

  return (                
    <div tw=" flex justify-center md:justify-end flex-wrap w-full h-full md:p-10 z-40">

    <ToastContainer tw='flex justify-center items-center'position="top-center"
    autoClose={5000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    style={{"fontFamily":"Montserrat"}} />


       <div tw="z-40 flex flex-col h-full w-80 md:w-96 mb-5 md:mr-10 p-4">

           <h1 tw="text-secondary text-left font-extrabold text-xl mb-0 text-white ">Sign Up</h1>

           <form onSubmit={(e)=>{handleSubmit(e)}} tw="flex-col flex mt-2">

            <CustomTextField fullWidth id="custom-css-outlined-input" 
            InputProps={{style: {"fontFamily":"Montserrat"}}} 
            InputLabelProps={{style: {"fontFamily":"Montserrat"}}} 
            style={{"backgroundColor":"#fafafa", "marginBottom":"10px"}}  
            label="Name" placeholder="Krishnan" size="small" variant="filled" tw="rounded-lg"
            value={name} onChange={(e)=>{setName(e.target.value)}}/>  

            <CustomTextField fullWidth id="filled-basic" 
            InputProps={{style: {"fontFamily":"Montserrat"}}} 
            InputLabelProps={{style: {"fontFamily":"Montserrat"}}} 
            style={{"backgroundColor":"#fafafa", "marginBottom":"10px"}} label="Email" placeholder="krish@gmail.com" size='small' variant="filled" tw="rounded-lg" 
            value={email} onChange={(e) => {setEmail(e.target.value)}}/>

            <CustomTextField fullWidth id="filled-basic" 
            InputProps={{style: {"fontFamily":"Montserrat"}}} 
            InputLabelProps={{style: {"fontFamily":"Montserrat"}}} 
            style={{"backgroundColor":"#fafafa", "marginBottom":"10px"}} label="Mobile Number" placeholder="9876543210" size='small' variant="filled" tw="rounded-lg"
            value={phone} onChange={(e)=>{handlePhone(e)}} /> 

            <select tw=" h-10 rounded-lg text-center text-secondary " required onChange={(e)=>{setCity(e.target.value)}}>
                <option  value=" ">Select your city</option>
                <option  value="Chennai">Chennai</option>
                <option  value='Coimbatore'>Coimbatore</option>
            </select>   

            <div tw="text-whiteAlt mt-1.5 flex flex-col"> 
            <Checkbox tw="text-whiteAlt" defaultChecked  onChange={(e)=>{handleAlert(e)}}>I agree to receive updates from Glint on <span tw="md:block"> <WhatsAppIcon tw="text-[#25D366]"/> WhatsApp </span></Checkbox>
            </div>

            <button type="submit" tw="w-1/2 h-10 mt-3 rounded bg-primary text-secondary font-bold text-center hover:bg-white hover:text-primary grid items-center ml-[25%]">Submit</button>

           </form>
        </div>

       
    </div>
  )
}

export default SubscribeSection